"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _FilterRuleList_1 = require("./_FilterRuleList");
exports._S3KeyFilter = {
    type: "structure",
    required: [],
    members: {
        FilterRules: {
            shape: _FilterRuleList_1._FilterRuleList,
            locationName: "FilterRule"
        }
    }
};
//# sourceMappingURL=_S3KeyFilter.js.map